import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

// Icon for indicating missing data
import Check from "@/assets/icons/WhiteCheck.svg";
import {
  TOrderVideoStatus,
  TRequiredAction,
  TResponseOrderDetails,
  TResponseOrderVideos,
} from "@/types/projectType";

interface VideoLinkProps {
  item: TResponseOrderVideos;
  RequiredActions: TRequiredAction;
  VideoStageStatus: TOrderVideoStatus[];
  index: number;
  data: {
    VideoEditApprovalData: Array<{ videoId: string; missing: any[] }>;
    VideoScriptApprovedAndActorAssignedData: Array<{
      videoId: string;
      missing: any[];
    }>;
    VideoSetupAndRawFootageApprovalData: Array<{
      videoId: string;
      missing: any[];
    }>;
    orderDetails: TResponseOrderDetails;
  };
}

const ProjectVideos = ({
  VideoStageStatus,
  item,
  index,
  RequiredActions,
  data,
}: VideoLinkProps) => {
  // console.log(data);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  const videoId = searchParams.get("videoId");
  const isActive = videoId === item.video_id;

  const statusForCurrentVideo = VideoStageStatus?.find(
    (item: any) => item?.video_id === String(index)
  );
// console.log(statusForCurrentVideo?.stage_status?.planing_stage);
  const planningStageRequiredAction =
    statusForCurrentVideo?.stage_status?.planing_stage.inProgress &&
    RequiredActions?.PlanningStageRequiredActions?.find(
      (item) => item.videoId === String(index)
    )?.adminRequiredActions?.required.length !== 0 || false;



    // console.log(RequiredActions);
// console.log(planningStageRequiredAction);
// console.log(   RequiredActions?.PlanningStageRequiredActions);
  const recordingStageRequiredAction =
    statusForCurrentVideo?.stage_status.recording_stage.inProgress &&
    RequiredActions.RecordingStageRequiredActions.find(
      (item) => item.videoId === String(index)
    )?.adminRequiredActions.required.length !== 0;

  const editingStageRequiredAction =
    statusForCurrentVideo?.stage_status.editing_stage.inProgress &&
    RequiredActions.EditingStageRequiredActions.find(
      (item) => item.videoId === String(index)
    )?.adminRequiredActions.required.length !== 0;
  /// check the current the stage
  // in that stage find if there any required actions that needs to done

  const {
    VideoEditApprovalData,
    VideoScriptApprovedAndActorAssignedData,
    VideoSetupAndRawFootageApprovalData,
  } = data;
  // Function to check if a video has missing data
  // const hasMissingData = (videoId: string) => {
  //   return (
  //     (data.orderDetails.stage_status.editing_stage &&
  //       VideoEditApprovalData.find(
  //         (video) => video.videoId === videoId && video.missing.length !== 0
  //       )) ||
  //     (data.orderDetails.stage_status.planing_stage &&
  //       VideoScriptApprovedAndActorAssignedData.find(
  //         (video) => video.videoId === videoId && video.missing.length !== 0
  //       )) ||
  //     (data.orderDetails.stage_status.recording_stage &&
  //       VideoSetupAndRawFootageApprovalData.find(
  //         (video) => video.videoId === videoId && video.missing.length !== 0
  //       ))
  //   );
  // };

  // Check active data is not missing
  const showMissingIndicator =
    planningStageRequiredAction ||
    recordingStageRequiredAction ||
    editingStageRequiredAction;

  const activeClass = isActive
    ? "md:bg-[#F1F3F5] text-[#003366]"
    : "text-[#475467]";
  const activeAfterClass = isActive
    ? "after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-0.5 after:bg-[#003366] md:after:hidden"
    : "";
  const activeCircleClass = isActive
    ? "md:bg-[#17457D14] md:bg-[#17457D14]"
    : "bg-transparent md:bg-transparent";
  const activeInnerCircleClass = isActive
    ? "md:bg-[#003366] md:border-[#003366] md:bg-[#17457D14] md:border-[#17457D]"
    : "bg-[#17457D14] md:border-[#D0D5DD] md:bg-[#17457D14] md:border-[#D0D5DD]";

  const handleSetVideoId = (videoId: string) => {
    const queryParams = new URLSearchParams(location.search);
    queryParams.set("videoId", videoId);
    navigate(
      {
        search: `?${queryParams.toString()}`,
      },
      { replace: true }
    );
  };

  return (
    <div
      onClick={() => handleSetVideoId(item.video_id)}
      className={`md:w-full py-[10px] cursor-pointer px-2 text-sm rounded-lg font-medium flex items-center gap-2 whitespace-nowrap relative ${activeClass} ${activeAfterClass}`}
    >
      {/* Circle Indicator for Active Video */}
      <div
        onClick={() => handleSetVideoId(item.video_id)}
        className="w-6 h-6 md:flex justify-center items-center hidden"
      >
        <div
          className={`w-6 h-6 rounded-full flex justify-center items-center transition-all duration-300 ${activeCircleClass}`}
        >
          <div
            className={`w-4 h-4 rounded-full border-[1.5px] transition-all duration-300${activeInnerCircleClass}`}
          ></div>
        </div>
      </div>

      {/* Video Title */}
      <p className="md:max-w-[140px] truncate">
        {item.scriptDetails.titleOfTheVideo}
      </p>

      {/* Missing Data Indicator */}
      {showMissingIndicator && (
        <div className="text-xs text-red-600 bg-red-100 rounded-full px-2 py-1 ml-2">
          Action Required
        </div>
      )}

      {/* Check Icon for Active Video */}
      <div className="block md:hidden">
        {isActive && (
          <div className="flex justify-center items-center bg-[#17457D] size-4 rounded-full">
            <Check />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectVideos;
